<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Users'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'UserSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'mai-user',
        editEntityScreen: 'Admin - Edit/View User',
        fields: [
          { header: 'User login', prop: 'userLogin', hideByDefault: false },
          { header: 'Name', prop: item => item.person !== null ? item.person.nickName : '', hideByDefault: false },
          { header: 'Role', prop: item => (item.person && item.person.role && item.person.role.name) || '', hideByDefault: false },
          { header: 'User Group', prop: item => item.userGroup !== null ? item.userGroup.name : '', hideByDefault: true },
          { header: 'Failed Logins (cons.)', prop: 'loginFailedTimes', hideByDefault: true, numericalField: true }
        ],
        orderBy: 'userLogin'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// UserSearchResults.vue?215b200c